import x from 'aaden-base-model'

export default x.StandardDishesListFactory()
